import { State } from '@/stores/costcentres/state';
import { Actions } from '@/stores/costcentres/actions';
import { Getters } from '@/stores/costcentres/getters';
import { Mutations } from '@/stores/costcentres/mutations';
import { Module } from 'vuex';

export class CostCentreStore implements Module<State, any> {
    public namespaced: boolean = true;
    public state: State = new State();
    public actions: Actions = new Actions();
    public getters: Getters = new Getters();
    public mutations: Mutations = new Mutations();
}
